import React from 'react';
import { Image, Button, Row, Col } from 'react-bootstrap';
import DOMPurify from 'dompurify';
import { Icon, ButtonTooltip } from '../../../components';

const BenefitModalShow = ({ benefit }) => {
  const image = benefit.benefitsImage?.fileUrl;
  const { attachedFileInfo } = benefit;
  const newTab = () => window.open(benefit.link, 'noopener', 'noreferrer');

  return (
    <section className="px-4 pt-3 pb-4">
      <Row className="d-flex justify-content-between align-items-start mb-3">
        <p className="mb-0 text-uppercase font-weight-bold fs-1">{benefit.name}</p>
        <small className="text-muted">
          Publicación: {benefit.startDate} al {benefit.endDate}
        </small>
      </Row>

      {image && (
        <div className="d-flex justify-content-center mb-4">
          <Image className="max-height-300 rounded shadow-sm" src={image} alt={benefit.name} fluid />
        </div>
      )}

      <div className="mb-4 mt-5">
        <div
          className="text-justify white-space-pre-line"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(benefit.description)
          }}
        />
      </div>

      <Row className="mt-5 d-flex justify-content-between align-items-center" style={{ bottom: '0px;' }}>
        <Row xs="auto">
          {attachedFileInfo && Object.keys(attachedFileInfo).length > 0 && (
            <>
              <Col xs={2}>
                <ButtonTooltip
                  onClick={() => window.open(attachedFileInfo.fileUrl, '_blank', 'noopener', 'noreferrer')}
                  variant="circle-primary"
                  className="btn-circle"
                  text="Descargar"
                >
                  <Icon icon="download-2" height="16px" width="16px" />
                </ButtonTooltip>
              </Col>
              <Col xs={10} className="d-flex align-items-center">
                <p className="mb-0">Descargar Documento Adjunto</p>
              </Col>
            </>
          )}
        </Row>

        <Col xs="auto">
          {benefit.link && (
            <Button variant="primary" onClick={newTab}>
              IR A BENEFICIO
            </Button>
          )}
        </Col>
      </Row>
    </section>
  );
};

export default BenefitModalShow;
